var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('section',[(_vm.spinning)?_c('BaseSpinner',{attrs:{"height":"100px","width":"100px"}}):_vm._e()],1):_c('section',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }